<template>
  <v-card
    @click="$emit('categoryDidSelected', category)"
  >
    <v-card-subtitle
      class="line-break pa-2 text-center"
    >
      {{ category.name }}
    </v-card-subtitle>
  </v-card>
</template>

<script>
  export default {
    name: 'OptionsCategoryell',

    props: {
      category: Object,
    },
  }
</script>

<style scoped>
.line-break {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
